import type { AppIconName } from "@wilco/ui";
import type { MessageKey } from "../i18n.ts";
import type { Target } from "./targets.tsx";

/*
 * Разделы меню. Пока заглушка: позже список придёт с сервера по правам
 * пользователя (меню только скрывает, право проверяет сервер) и
 * включённым модулям.
 */
export interface Section {
  id: string;
  label: MessageKey;
  icon: AppIconName;
  target: Target;
  /** Право, без которого пункт скрыт: себестоимость только с cost.read (CST-23). */
  permission?: string;
}

const section = (id: string, icon: AppIconName): Section => ({
  id,
  label: `section.${id}` as MessageKey,
  icon,
  target: { kind: "section", id },
});

export const SECTIONS: readonly Section[] = [
  { id: "stock", label: "section.stock", icon: "stock", target: { kind: "stock" } },
  { id: "catalog", label: "section.catalog", icon: "stock", target: { kind: "catalog" } },
  { id: "purchase", label: "section.purchase", icon: "purchase", target: { kind: "purchasing", tab: "shortage" } },
  { id: "mrp", label: "section.mrp", icon: "mrp", target: { kind: "line" } },
  { id: "route", label: "section.route", icon: "route", target: { kind: "myOps" } },
  { id: "sales", label: "section.sales", icon: "sales", target: { kind: "sales" } },
  { id: "repair", label: "section.repair", icon: "repair", target: { kind: "unit" } },
  { id: "bank", label: "section.bank", icon: "expense", target: { kind: "bank", tab: "accounts" } },
  { id: "expense", label: "section.expense", icon: "expense", target: { kind: "opex", tab: "entries" } },
  { id: "hr", label: "section.hr", icon: "hr", target: { kind: "hr" } },
  { id: "attendance", label: "section.attendance", icon: "attendance", target: { kind: "attendance" } },
  { id: "contacts", label: "section.contacts", icon: "contacts", target: { kind: "partners" } },
  { id: "dashboards", label: "section.dashboards", icon: "dashboards", target: { kind: "costing" }, permission: "cost.read" },
  section("settings", "settings"),
];

/** Пункты, которые меню показывает этому пользователю (useCan из auth.ts). */
export const visibleSections = (can: (permission: string) => boolean): Section[] => SECTIONS.filter((s) => !s.permission || can(s.permission));

export const findSection = (id: string): Section | undefined => SECTIONS.find((s) => s.id === id);
